import React from 'react'
import InputLabel from './InputLabel'

export default ({ largerLabel }) => (
  <InputLabel isSpacer aria-hidden largerLabel={largerLabel}>
    &nbsp;
  </InputLabel>
)
